import React, { useState } from "react";
import "./DocumentsSection.css";
import getImageUrl from "../../../../utils/imageUrl";


const DocumentsSection = ({
  business,
  saving,
  onSavePhotos,
  onSaveDocuments,
}) => {
  const [photos, setPhotos] = useState({
    profilePhoto: null,
    businessPhoto: null,
    businessLogo: null,
  });

  const [documents, setDocuments] = useState({
    aadhaarFront: null,
    aadhaarBack: null,
    panCard: null,
  });

  const handlePhotoChange = (e) => {
    const { name, files } = e.target;

    setPhotos((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleDocumentChange = (e) => {
    const { name, files } = e.target;

    setDocuments((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const uploadPhotos = async () => {
    const formData = new FormData();

    Object.keys(photos).forEach((key) => {
      if (photos[key]) {
        formData.append(key, photos[key]);
      }
    });

    await onSavePhotos(formData);
  };

  const uploadDocuments = async () => {
    const formData = new FormData();

    Object.keys(documents).forEach((key) => {
      if (documents[key]) {
        formData.append(key, documents[key]);
      }
    });

    await onSaveDocuments(formData);
  };

  const preview = (fileName) =>
  fileName
    ? getImageUrl(`/uploads/business/${fileName}`)
    : "/no-image.png";

  return (
    <div className="documents-card">

      <div className="card-header">
        <div>
          <h3>📸 Business Photos</h3>
          <p>
            Upload photos that customers will see on your profile.
          </p>
        </div>

        <span className="verified-badge">
          Images
        </span>
      </div>

      <div className="upload-grid">

        <div className="upload-item">

          <img
            src={preview(business?.photos?.profilePhoto)}
            alt="Profile"
          />

          <h4>Profile Photo</h4>

          <input
            type="file"
            name="profilePhoto"
            accept="image/*"
            onChange={handlePhotoChange}
          />

          <small>
            {photos.profilePhoto
              ? photos.profilePhoto.name
              : "No file selected"}
          </small>

        </div>

        <div className="upload-item">

          <img
            src={preview(business?.photos?.businessPhoto)}
            alt="Business"
          />

          <h4>Business Photo</h4>

          <input
            type="file"
            name="businessPhoto"
            accept="image/*"
            onChange={handlePhotoChange}
          />

          <small>
            {photos.businessPhoto
              ? photos.businessPhoto.name
              : "No file selected"}
          </small>

        </div>

        <div className="upload-item">

          <img
            src={preview(business?.photos?.businessLogo)}
            alt="Logo"
          />

          <h4>Business Logo</h4>

          <input
            type="file"
            name="businessLogo"
            accept="image/*"
            onChange={handlePhotoChange}
          />

          <small>
            {photos.businessLogo
              ? photos.businessLogo.name
              : "No file selected"}
          </small>

        </div>

      </div>

      <button
        className="upload-btn"
        onClick={uploadPhotos}
        disabled={saving}
      >
        {saving ? "Uploading..." : "Save Photos"}
      </button>

      <hr />

      <div className="card-header">
        <div>
          <h3>📄 Verification Documents</h3>
          <p>
            Upload identity documents for business verification.
          </p>
        </div>

        <span className="verified-badge">
          Secure
        </span>
      </div>

      <div className="upload-grid">

        <div className="upload-item">

          <h4>Aadhaar Front</h4>

          <input
            type="file"
            name="aadhaarFront"
            accept="image/*,.pdf"
            onChange={handleDocumentChange}
          />

          <small>
            {documents.aadhaarFront
              ? documents.aadhaarFront.name
              : "No file selected"}
          </small>

        </div>

        <div className="upload-item">

          <h4>Aadhaar Back</h4>

          <input
            type="file"
            name="aadhaarBack"
            accept="image/*,.pdf"
            onChange={handleDocumentChange}
          />

          <small>
            {documents.aadhaarBack
              ? documents.aadhaarBack.name
              : "No file selected"}
          </small>

        </div>

        <div className="upload-item">

          <h4>PAN Card</h4>

          <input
            type="file"
            name="panCard"
            accept="image/*,.pdf"
            onChange={handleDocumentChange}
          />

          <small>
            {documents.panCard
              ? documents.panCard.name
              : "No file selected"}
          </small>

        </div>

      </div>

      <button
        className="upload-btn"
        onClick={uploadDocuments}
        disabled={saving}
      >
        {saving ? "Uploading..." : "Save Documents"}
      </button>

    </div>
  );
};

export default DocumentsSection;